import { getSalesMetros } from './GetSalesMetros';
import { getSalesMetroZips } from './GetSalesMetroZips';
import { putSalesMetroAdmins } from './PutSalesMetroAdmins';

export { SALES_METROS_MAX_PAGE, SALES_METROS_PAGE_LIMIT } from './GetSalesMetros';

/**
 * Sales Metros API Client
 * Provides low-level HTTP calls to organization-service sales-metro endpoints
 */
export const SalesMetrosApi = {
  getSalesMetros,
  getSalesMetroZips,
  putSalesMetroAdmins,
};
